module.exports = __webpack_public_path__ + "img/20220116_161004.3c9be17d.jpg";